// Removes the 'GA1.1.' from the start and adds a dot to the end (which is apparently nice for tracking tools)
export function getGoogleAnalyticsCookieValue() {
  const cookie = document.cookie
    .split(';')
    .filter(value => value.startsWith('_ga'))[0]
    ?.split('ga=GA1.1.')
    .pop();
  return cookie ? `${cookie}.` : '';
}
